import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { Modal } from '@/shared/components/ui/Modal';
import { Button } from '@/shared/components/ui/Button';
import { Select } from '@/shared/components/ui/Select';
import { useLeadMutations } from '../hooks/useLeads';
import { SUB_STATUSES } from '../constants';

interface SubStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  leadId: string | null;
  mainStatus: string;
}

export function SubStatusModal({ isOpen, onClose, leadId, mainStatus }: SubStatusModalProps) {
  const [subStatus, setSubStatus] = useState('');
  const { updateSubStatus } = useLeadMutations();

  const options = SUB_STATUSES[mainStatus] || [];

  useEffect(() => {
    if (isOpen && options.length > 0) setSubStatus(options[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, mainStatus]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadId) return;
    updateSubStatus.mutate(
      { id: leadId, sub_status: subStatus },
      {
        onSuccess: () => {
          toast.success('Sub-status updated');
          onClose();
        },
        onError: (err: any) => toast.error(err.response?.data?.error || err.message || 'Failed to update sub-status'),
      },
    );
  };

  if (options.length === 0) return null;

  return (
    <Modal open={isOpen} onClose={onClose} title="Select Sub-Status" size="sm">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Select
          label="Sub-Status"
          options={options.map((opt) => ({ value: opt, label: opt.replace(/_/g, ' ') }))}
          value={subStatus}
          onChange={(e) => setSubStatus(e.target.value)}
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" onClick={onClose}>
            Skip
          </Button>
          <Button type="submit" loading={updateSubStatus.isPending}>
            Save Sub-Status
          </Button>
        </div>
      </form>
    </Modal>
  );
}
